import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const IssueCompletedIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => {
		return (
			<svg
				viewBox="0 0 14 14"
				fill={props.color || "currentColor"}
				xmlns="http://www.w3.org/2000/svg"
				{...props}
				ref={ref}
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
				/>
			</svg>
		)
	},
)
